/*
 * DROP · menú de escritorio (borrador, copia del tema). SOLO escritorio (>= 990px); en celular y tablet no se crea nada y queda el menú original del tema.
 * v99: Colecciones ahora incluye Pilgrimage (Undergold, foto del hero de inicio) y Two Lost Kids (Veja) en su posición cronológica correcta.
 * v98: los enlaces del panel de pantalla completa ("Ver todo Mujer", "Ver todo Hombre", categorías y fotos) ahora navegan directo a su página. Antes otro script del tema (el panel dmh) interceptaba el clic y abría un segundo panel encima.
 * v97: el menú de pantalla completa (clic) queda SOLO en Hombre y Mujer. Calzado y Marcas vuelven a como estaban: despliegue al pasar el mouse y el clic abre su página.
 * v96: en celular/tablet el script no inyecta el menú central, ni los enlaces superiores (Tiendas / Ayuda / Bonos de regalo), ni el panel de pantalla completa; si ya estaban, se quitan. Todo se vuelve a crear al pasar a escritorio.
 * v93: el clic en Hombre / Mujer se captura al inicio (ventana, fase de captura) para que ningún otro script del tema lo intercepte.
 * v92: al HACER CLIC en Hombre / Mujer se abre el menú en PANTALLA COMPLETA, fondo blanco sólido (lista de categorías a la izquierda, dos fotos grandes a la derecha). Se cierra con la X, con Esc o volviendo a hacer clic en el mismo ítem. El despliegue al pasar el mouse sigue igual. Colecciones sigue abriendo su despliegue normal.
 * v91: fotos más recientes — Hombre: Undergold (Pilgrimage, oct 2026) + Palms Capra; Mujer: True (Daily Washed, oct 2026) + Classic & Rebels.
 * v90: fotos del despliegue — Hombre: Undergold + Palms Capra; Mujer: True + Classic & Rebels.
 * v82: las dos fotos de cada despliegue son editoriales de estilo de vida (sin fondo blanco) y sin título encima ni capa oscura.
 * v81: despliegues con dos fotos editoriales; UGG y TRUE como "Ugg" y "True"; menú superior más junto y corrido un poco a la izquierda; columnas más juntas y letra del despliegue más pequeña.
 * v80: se quitan las flechitas del menú; al pasar el mouse por encima el nombre se pone en negrilla y el despliegue se abre solo. Logo a la izquierda y menú al centro (como al inicio).
 * v77: fondo de los mega menús con efecto de vidrio esmerilado (blanco translúcido + desenfoque del contenido de atrás).
 *      Foto lateral de los menús 15px más angosta (el alto total del menú se mantiene igual al de Colecciones).
 *      "Descuentos" pasa a llamarse "Rebajas"; Colecciones ordenadas de la más nueva (primera) a la más vieja (última).
 *      Colecciones = fila de tarjetas editoriales, ancho fijo con la última asomando y desplazable; sin enlace "Ver todas".
 *      "Ropa" en un solo bloque; el mega menú se adapta al ancho de pantalla.
 *      Mientras está abierto, el logo, los enlaces, las flechas y los iconos pasan a negro (clases dmd-hov / dmd-hov-l en <html>).
 */
(function () {
  if (window.__dropMenuDesk) return;
  window.__dropMenuDesk = true;
  var mq = window.matchMedia('(min-width:990px)');
  var P = '/collections/';

  var LINKS = [['Hombre', P + 'hombre'], ['Mujer', P + 'ropa-mujer'], ['Marcas', P + 'marcas']];

  var L1 = [
    ['Colecciones', P], ['Más Vendidos', P + 'lo-mas-vendido'], ['Novedades', P + 'recientes'], ['Rebajas', P + 'rebajas'],
    ['Marcas', null, 'marcas'], ['Tenis y Zapatos', null, 'calzado'], ['Mujer', null, 'mujer'], ['Hombre', null, 'hombre'],
    ['Accesorios', null, 'accesorios'], ['Belleza', null, 'belleza'], ['Journal', '/blogs/journal']
  ];
  var EXPLORA = [['Quiénes Somos', '/pages/quienes-somos'], ['Tiendas', '/pages/tiendas'], ['Contacto', '/pages/contacto'], ['Ayuda', '/pages/preguntas-frecuentes']];

  var SUB = {
    hombre: [
      { g: 'Destacados', i: [['Ver Todo', P + 'hombre'], ['Novedades', P + 'novedades-hombre'], ['Más Vendidos', P + 'mas-vendidos-hombre'], ['Rebajas', P + 'rebajas-hombre']] },
      { g: 'Ropa', i: [['Camisetas', P + 'camisetas-hombre'], ['Camisas', P + 'camisas-hombre'], ['Buzos y Hoodies', P + 'hoodies-hombre'], ['Chaquetas', P + 'chaquetas-hombre'], ['Suéteres', P + 'tejidos-hombre'], ['Jeans', P + 'jeans-hombre'], ['Pantalones', P + 'pantalones-hombre'], ['Pantalonetas', P + 'pantalonetas-hombre'], ['Ropa Interior', P + 'ropa-interior-hombre']] },
      { g: 'Tenis y Zapatos', i: [['Ver Todo', P + 'calzado-hombre']] },
      { g: 'Accesorios', i: [['Ver Todo', P + 'accesorios-hombre'], ['Gorras', P + 'gorras-hombre']] }
    ],
    mujer: [
      { g: 'Destacados', i: [['Ver Todo', P + 'ropa-mujer'], ['Novedades', P + 'novedades-mujer'], ['Más Vendidos', P + 'mas-vendidos-mujer'], ['Rebajas', P + 'rebajas-mujer']] },
      { g: 'Ropa', i: [['Camisetas', P + 'camisetas-mujer'], ['Blusas y Camisas', P + 'camisas-mujer'], ['Tops', P + 'tops-mujer'], ['Buzos y Hoodies', P + 'hoodies-mujer'], ['Chaquetas', P + 'chaquetas-mujer'], ['Suéteres', P + 'tejidos-mujer'], ['Jeans', P + 'jeans-mujer'], ['Pantalones', P + 'pantalones-mujer'], ['Shorts', P + 'shorts-mujer'], ['Faldas', P + 'faldas-mujer'], ['Ropa Interior', P + 'underwear-mujer']] },
      { g: 'Tenis y Zapatos', i: [['Ver Todo', P + 'calzado-mujer']] },
      { g: 'Accesorios', i: [['Ver Todo', P + 'accesorios-mujer']] }
    ],
    calzado: [
      { g: 'Destacados', i: [['Ver Todo', P + 'calzado'], ['Novedades', P + 'novedades-calzado'], ['Más Vendidos', P + 'mas-vendidos-calzado'], ['Rebajas', P + 'rebajas-calzado']] },
      { g: 'Tenis y Zapatos', i: [['Tenis y Sneakers', P + 'calzado-lifestyle'], ['Tenis Running', P + 'calzado-deportivo'], ['Botas', P + 'botas'], ['Zapatos', P + 'zapatos'], ['Mocasines', P + 'calzado-formal']] },
      { g: 'Para', i: [['Hombre', P + 'calzado-hombre'], ['Mujer', P + 'calzado-mujer']] }
    ],
    accesorios: [
      { g: 'Accesorios', i: [['Hombre', P + 'accesorios-hombre'], ['Mujer', P + 'accesorios-mujer'], ['Gorras', P + 'gorras-hombre']] }
    ],
    belleza: [
      { g: 'Destacados', i: [['Ver Todo', P + 'belleza'], ['Novedades', P + 'novedades-belleza'], ['Más Vendidos', P + 'mas-vendidos-belleza'], ['Rebajas', P + 'rebajas-belleza']] }
    ],
    marcas: [
      { g: 'Más Vendidas', i: [['Undergold', P + 'undergold'], ['True', P + 'true'], ['Ugg', P + 'ugg'], ['Palms Capra', P + 'palms-capra']] },
      { g: 'Recién Llegadas', i: [['Remanence', P + 'remanence'], ['The Frenchie Co', P + 'the-frenchie-co']] },
      { g: 'Todas A–Z', i: [['Astronomic', P + 'astronomic'], ['Classic & Rebels', P + 'classic-rebels'], ['Coolway', P + 'coolway'], ['HOFF', P + 'hoff'], ['Jormands', P + 'jormands'], ['Kith', P + 'kith'], ['Monoic Studios', P + 'monoic-studios'], ['New Era', P + 'new-era'], ['Nude Project', P + 'nude-project'], ['Old Maquiina', P + 'old-maquiina'], ['On Cloud', P + 'on'], ['Palms Capra', P + 'palms-capra'], ['Reeva', P + 'reeva'], ['Rhode', P + 'rhode'], ['Stance', P + 'stance'], ['The Frenchie Co', P + 'the-frenchie-co'], ['True', P + 'true'], ['Ugg', P + 'ugg'], ['Undergold', P + 'undergold'], ['Veja', P + 'veja']] }
    ]
  };

  var CDN = 'https://cdn.shopify.com/s/files/1/0600/9549/6243/files/';
  var CCDN = 'https://cdn.shopify.com/s/files/1/0600/9549/6243/collections/';
  /* v91: fotos más recientes. Hombre = Undergold + Palms Capra; Mujer = True + Classic & Rebels. [imagen, texto alternativo, enlace] */
  var IMG = {
    hombre: [CDN + 'undergold-hoodie-pilgrimage-pulp-angel-knit-zip-up-angel-pattern-drop-05.webp?v=1793474827&width=800', 'Undergold', P + 'undergold'],
    mujer: [CDN + 'true-daily-washed-hoodie-black-drop-09_e49bba67-3054-4753-bdbb-047de5a4e53b.webp?v=1791200879&width=800', 'True', P + 'true'],
    calzado: [CDN + 'ugg-tazz-ii-chestnut-1174471-mujer-modelo.webp?v=1790567113&width=800', 'UGG', P + 'ugg'],
    marcas: [CDN + 'Golden_Heritage_-_our_final_collection_of_2025_embodying_the_bond_we_share_with_Undergold_s_leg.jpg?v=1765891124&width=800', 'Undergold', P + 'undergold']
  };
  /* segunda foto editorial de cada despliegue */
  var IMG2 = {
    hombre: [CDN + 'IMG_9773.jpg?v=1789127808&width=800', 'Palms Capra', P + 'palms-capra'],
    mujer: [CDN + 'classics-rebels-chaqueta-odeon-camel-drop-06.webp?v=1782765941&width=800', 'Classic & Rebels', P + 'classic-rebels'],
    calzado: [CDN + 'on_banner_web_home.webp?v=1768692229&width=800', 'On Cloud', P + 'on'],
    marcas: [CDN + 'classics-rebels-chaqueta-odeon-camel-drop-05.webp?v=1782765940&width=800', 'Classic & Rebels', P + 'classic-rebels']
  };
  /* de la más nueva (primera) a la más vieja (última) */
  var COLS = [
    ['pilgrimage', 'Pilgrimage', 'Undergold', CDN + 'prueba_banner_web_undergold.png?v=1793655660&width=600'],
    ['revelation', 'Revelation', 'Undergold', CCDN + 'undergold-hoodie-revelation-boxy-fit-faded-orange-drop-02.webp?v=1791281019&width=600'],
    ['two-lost-kids', 'Two Lost Kids', 'Veja', CDN + 'veja-two-lost-kids-panenka-lookbook-fondo-rosa.jpg?v=1793705723&width=600'],
    ['the-palms-club', 'The Palms Club', 'Palms Capra', CCDN + 'SaveVid.Net_757666046_18093112526576578_3056756779511733465_n.jpg?v=1786119818&width=600'],
    ['the-true-sprint-true', 'The True Sprint', 'True', CCDN + 'true-true-spirit-soccer-tee-green-drop-01.webp?v=1791281080&width=600'],
    ['ss-2026', 'SS 2026', 'Veja', CCDN + 'veja-gt-suede-taupe-pierre-ai0321656-drop-10_8dcb33cf-a9de-4a5b-a30b-22944c2a164e.webp?v=1791281068&width=600'],
    ['football-club-palms-capra', 'Football Club', 'Palms Capra', CCDN + 'palms-capra-1929-ivory-tshirt-drop-03.webp?v=1791281056&width=600'],
    ['echoes', 'Echoes', 'Undergold', CCDN + '7_e580f853-e848-4d7f-b4d3-105548ec65ce.jpg?v=1791281135&width=600']
  ];

  var CH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var XI = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var BI = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M3 7h18M3 12h18M3 17h18"/></svg>';
  var DN = '<svg class="dmd-chv" viewBox="0 0 10 6" width="9" height="6" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 1l4 4 4-4"/></svg>';
  var FC = '<svg class="dmd-fc" viewBox="0 0 10 6" width="11" height="7" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 1l4 4 4-4"/></svg>';
  var FT = { hombre: 'Hombre', mujer: 'Mujer', calzado: 'Tenis y zapatos', marcas: 'Marcas' };

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  var root, n1, n2, openKey = null;

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'dmd';
    root.setAttribute('aria-hidden', 'true');
    var i = 0;
    var l1 = L1.map(function (m) {
      var st = ' style="--i:' + (i++) + '"';
      if (m[2]) return '<li' + st + '><button type="button" class="dmd-i" data-k="' + m[2] + '"><span>' + esc(m[0]) + '</span>' + CH + '</button></li>';
      return '<li' + st + '><a class="dmd-i" href="' + esc(m[1]) + '"><span>' + esc(m[0]) + '</span></a></li>';
    }).join('');
    var ex = EXPLORA.map(function (m) { return '<li style="--i:' + (i++) + '"><a class="dmd-i" href="' + esc(m[1]) + '"><span>' + esc(m[0]) + '</span></a></li>'; }).join('');
    root.innerHTML =
      '<div class="dmd-bg" data-x></div><div class="dmd-wrap">' +
      '<nav class="dmd-n1" aria-label="Menú principal"><div class="dmd-hd"><span class="dmd-logo">DROP</span><button type="button" class="dmd-x" data-x aria-label="Cerrar menú">' + XI + '</button></div>' +
      '<ul class="dmd-ul">' + l1 + '</ul><p class="dmd-lbl">Explora</p><ul class="dmd-ul">' + ex + '</ul>' +
      '<div class="dmd-ft"><a class="dmd-acc" href="/account">Mi Cuenta</a></div></nav>' +
      '<nav class="dmd-n2" aria-label="Submenú" hidden></nav></div>';
    document.body.appendChild(root);
    n1 = root.querySelector('.dmd-n1');
    n2 = root.querySelector('.dmd-n2');
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-x]')) { close(); return; }
      var b = t.closest('button[data-k]');
      if (b) { showSub(b.getAttribute('data-k'), b); return; }
      if (t.closest('.dmd-back')) { hideSub(); return; }
      if (t.closest('a[href]')) close();
    });
  }

  function showSub(k, btn) {
    var g = SUB[k]; if (!g) return;
    if (openKey === k && !n2.hidden) { hideSub(); return; }
    var title = '';
    L1.forEach(function (m) { if (m[2] === k) title = m[0]; });
    var n = 0;
    var h = '<div class="dmd-hd"><button type="button" class="dmd-back">‹ ' + esc(title) + '</button></div><div class="dmd-body">';
    g.forEach(function (gr) {
      h += '<p class="dmd-g" style="--i:' + (n++) + '">' + esc(gr.g) + '</p><ul class="dmd-ul">';
      gr.i.forEach(function (it) { h += '<li style="--i:' + (n++) + '"><a class="dmd-i dmd-i2" href="' + esc(it[1]) + '"><span>' + esc(it[0]) + '</span></a></li>'; });
      h += '</ul>';
    });
    n2.innerHTML = h + '</div>';
    n2.hidden = false; n2.classList.remove('is-in'); void n2.offsetWidth; n2.classList.add('is-in');
    n1.querySelectorAll('.dmd-i.on').forEach(function (x) { x.classList.remove('on'); });
    if (btn) btn.classList.add('on');
    openKey = k;
  }

  function hideSub() {
    if (!n2) return;
    n2.hidden = true; n2.classList.remove('is-in');
    n1.querySelectorAll('.dmd-i.on').forEach(function (x) { x.classList.remove('on'); });
    openKey = null;
  }

  function open() {
    if (!mq.matches) return;
    build(); hideSub();
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dmd-lock');
    setTimeout(function () { var x = root.querySelector('.dmd-x'); if (x) x.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dmd-lock');
    setTimeout(hideSub, 380);
  }

  function wire() {
    var inner = document.querySelector('.header__inner');
    if (!mq.matches) { document.documentElement.classList.remove('dmd-on'); return; }
    document.documentElement.classList.add('dmd-on');
    if (!inner) return;
    var ex = inner.querySelector('.dmd-left');
    if (ex) {
      var eb = ex.querySelector('.dmd-burger');
      if (eb && !eb.__dmdWired) { eb.__dmdWired = true; eb.addEventListener('click', open); }
      return;
    }
    var left = document.createElement('div');
    left.className = 'dmd-left';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dmd-burger'; b.setAttribute('aria-label', 'Abrir menú');
    b.innerHTML = BI + '<span>Menú</span>';
    b.__dmdWired = true;
    b.addEventListener('click', open);
    left.appendChild(b);
    LINKS.forEach(function (l) {
      var a = document.createElement('a');
      a.className = 'dmd-lnk'; a.href = l[1]; a.textContent = l[0];
      left.appendChild(a);
    });
    var nav = inner.querySelector('nav.header__nav');
    inner.insertBefore(left, nav || inner.firstChild);
  }

  var EXTRA = [['Calzado', P + 'calzado'], ['Marcas', '/pages/marcas'], ['Colecciones', P], ['Rebajas', P + 'rebajas']];
  var TOP = [['Tiendas', '/pages/tiendas'], ['Ayuda', '/pages/preguntas-frecuentes'], ['Bonos de regalo', '/products/tarjeta-de-regalo-gift-card-drop']];
  var DDK = { 'Hombre': 'hombre', 'Mujer': 'mujer', 'Calzado': 'calzado', 'Marcas': 'marcas', 'Colecciones': 'colecciones' };

  function ddHtml(k) {
    if (k === 'colecciones') {
      var c = '<div class="dmd-dd"><div class="dmd-dd-in dmd-dd-cards"><div class="dmd-cards">';
      COLS.forEach(function (x) {
        c += '<a class="dmd-card" href="' + esc(P + x[0]) + '"><span class="dmd-cimg"><img src="' + esc(x[3]) + '" alt="' + esc(x[1]) + '"></span><strong>' + esc(x[1]) + '</strong><em>' + esc(x[2]) + '</em></a>';
      });
      return c + '</div></div></div>';
    }
    var g = SUB[k]; if (!g) return '';
    var h = '<div class="dmd-dd"><div class="dmd-dd-in">';
    g.forEach(function (gr, n) {
      if (n === 0) {
        h += '<div class="dmd-dl"><p>' + esc(gr.g) + '</p><ul>';
        gr.i.forEach(function (it) { h += '<li><a href="' + esc(it[1]) + '">' + esc(it[0]) + '</a></li>'; });
        h += '</ul></div>';
      } else {
        h += '<div class="dmd-dg' + (k === 'marcas' && gr.i.length > 10 ? ' dmd-dg2' : '') + '"><p>' + esc(gr.g) + '</p><ul>';
        gr.i.forEach(function (it) { h += '<li><a href="' + esc(it[1]) + '">' + esc(it[0]) + '</a></li>'; });
        h += '</ul></div>';
      }
    });
    var im = IMG[k];
    if (im) h += '<a class="dmd-dimg" href="' + esc(im[2]) + '" aria-label="' + esc(im[1]) + '"><img src="' + esc(im[0]) + '" alt="' + esc(im[1]) + '"></a>';
    var im2 = IMG2[k];
    if (im2) h += '<a class="dmd-dimg" href="' + esc(im2[2]) + '" aria-label="' + esc(im2[1]) + '"><img src="' + esc(im2[0]) + '" alt="' + esc(im2[1]) + '"></a>';
    return h + '</div></div>';
  }

  /* v92: menú en pantalla completa (fondo blanco) que se abre al hacer clic. v97: solo Hombre y Mujer */
  function fullHtml(k) {
    if (k !== 'hombre' && k !== 'mujer') return '';
    var g = SUB[k]; if (!g || !IMG[k]) return '';
    var sk = k !== 'marcas';
    var gs = sk ? g.slice(1) : g;
    var h = '<div class="dmd-full"><div class="dmd-fl">';
    gs.forEach(function (gr) {
      h += '<details><summary><span>' + esc(gr.g) + '</span>' + FC + '</summary><ul>';
      gr.i.forEach(function (it) { h += '<li><a href="' + esc(it[1]) + '">' + esc(it[0]) + '</a></li>'; });
      h += '</ul></details>';
    });
    var all = sk ? ['Ver todo ' + FT[k], g[0].i[0][1]] : ['Ver todas las marcas', '/pages/marcas'];
    h += '<a class="dmd-fall" href="' + esc(all[1]) + '">' + esc(all[0]) + '</a></div><div class="dmd-fp">';
    var ph = sk ? [g[0].i[1], g[0].i[2]] : [[IMG[k][1], IMG[k][2]], [IMG2[k][1], IMG2[k][2]]];
    var ims = [IMG[k], IMG2[k]];
    ph.forEach(function (p, n) {
      var im = ims[n]; if (!im) return;
      h += '<a class="dmd-fph" href="' + esc(p[1]) + '"><img src="' + esc(im[0].replace('&width=800', '&width=1200')) + '" alt="' + esc(p[0]) + '"><span class="dmd-flb"><strong>' + esc(p[0]) + '</strong><em>Descubrir la colección</em></span></a>';
    });
    return h + '</div><button type="button" class="dmd-fx" aria-label="Cerrar">' + XI + '</button></div>';
  }

  var hovT = 0;
  function isLight() {
    var c = getComputedStyle(document.documentElement).getPropertyValue('--dmd-c') || '';
    var m = c.match(/\d+/g);
    if (!m || m.length < 3) return true;
    return (+m[0] + +m[1] + +m[2]) / 3 > 150;
  }
  function place(w) {
    var dd = w.querySelector('.dmd-dd'), hd = document.querySelector('.header__inner');
    if (!dd || !hd) return;
    var hr = hd.getBoundingClientRect(), wr = w.getBoundingClientRect();
    dd.style.setProperty('left', (-wr.left) + 'px', 'important');
    dd.style.setProperty('width', document.documentElement.clientWidth + 'px', 'important');
    dd.style.setProperty('top', (hr.top - wr.top) + 'px', 'important');
    dd.style.setProperty('--hh', Math.round(hr.height) + 'px');
  }
  function placeFull(w) {
    var f = w.querySelector('.dmd-full'), hd = document.querySelector('.header__inner');
    if (!f || !hd) return;
    var hr = hd.getBoundingClientRect(), wr = w.getBoundingClientRect();
    f.style.setProperty('left', (-wr.left) + 'px', 'important');
    f.style.setProperty('width', document.documentElement.clientWidth + 'px', 'important');
    f.style.setProperty('top', (hr.top - wr.top) + 'px', 'important');
    f.style.setProperty('height', Math.max(300, (window.innerHeight || document.documentElement.clientHeight) - hr.top) + 'px', 'important');
    f.style.setProperty('--hh', Math.round(hr.height) + 'px');
  }
  function hovOn(w) {
    clearTimeout(hovT);
    place(w);
    var c = document.documentElement.classList;
    if (!c.contains('dmd-hov')) { if (isLight()) c.add('dmd-hov-l'); c.add('dmd-hov'); }
  }
  function hovOff() {
    clearTimeout(hovT);
    if (document.documentElement.classList.contains('dmd-fo')) return;
    hovT = setTimeout(function () { document.documentElement.classList.remove('dmd-hov', 'dmd-hov-l'); }, 90);
  }
  function closeFull() {
    var c = document.documentElement.classList;
    var was = c.contains('dmd-fo');
    document.querySelectorAll('.dmd-item.is-fo').forEach(function (x) { x.classList.remove('is-fo'); });
    c.remove('dmd-fo');
    if (was) {
      c.remove('dmd-hov', 'dmd-hov-l');
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    }
  }
  function openFull(w) {
    closeFull();
    clearTimeout(hovT);
    var c = document.documentElement.classList;
    if (!c.contains('dmd-hov')) { if (isLight()) c.add('dmd-hov-l'); c.add('dmd-hov'); }
    placeFull(w);
    w.classList.add('is-fo');
    c.add('dmd-fo');
  }

  function wrapDD(left) {
    var kids = Array.prototype.slice.call(left.children);
    kids.forEach(function (a) {
      if (!a.classList || !a.classList.contains('dmd-lnk')) return;
      var k = DDK[a.textContent.trim()];
      if (!k) return;
      var w = document.createElement('div');
      w.className = 'dmd-item';
      left.insertBefore(w, a);
      w.appendChild(a);
      a.insertAdjacentHTML('beforeend', DN);
      w.insertAdjacentHTML('beforeend', ddHtml(k));
      var fh = fullHtml(k);
      if (fh) {
        w.insertAdjacentHTML('beforeend', fh);
        w.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.dmd-fx')) closeFull(); });
      }
      w.addEventListener('mouseenter', function () { if (!document.documentElement.classList.contains('dmd-fo')) hovOn(w); });
      w.addEventListener('mouseleave', hovOff);
      w.addEventListener('focusin', function () { if (!document.documentElement.classList.contains('dmd-fo')) hovOn(w); });
      w.addEventListener('focusout', hovOff);
    });
    Array.prototype.slice.call(left.children).forEach(function (a) {
      if (a.classList && a.classList.contains('dmd-lnk')) a.addEventListener('mouseenter', hovOff);
    });
  }

  /* v93: clic en Hombre / Mujer: se captura en la ventana, antes que cualquier otro script del tema. Calzado / Marcas: el clic abre su página (sin panel completo).
     v98: los enlaces dentro del panel de pantalla completa navegan directo (otro script del tema abría su propio panel al ver el enlace a la página de Mujer / Hombre). */
  window.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button || !mq.matches) return;
    var fa = e.target && e.target.closest ? e.target.closest('.dmd-full a[href]') : null;
    if (fa) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      closeFull();
      window.location.assign(fa.href);
      return;
    }
    var a = e.target && e.target.closest ? e.target.closest('.dmd-left .dmd-item > .dmd-lnk') : null;
    if (!a) return;
    var w = a.parentElement;
    if (!w.querySelector('.dmd-full')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (w.classList.contains('is-fo')) closeFull(); else openFull(w);
  }, true);

  /* v96: quita todo lo del menú de escritorio (celular / tablet) */
  function cleanup() {
    closeFull();
    var l = document.querySelector('.header__inner .dmd-left');
    if (l && l.parentNode) l.parentNode.removeChild(l);
    var t = document.querySelector('.header__inner .dmd-top');
    if (t && t.parentNode) t.parentNode.removeChild(t);
    document.documentElement.classList.remove('dmd-on', 'dmd-hov', 'dmd-hov-l', 'dmd-fo');
  }

  function links() {
    if (!mq.matches) { cleanup(); return; }
    var left = document.querySelector('.header__inner .dmd-left');
    if (left && !left.getAttribute('data-r2')) {
      var ls = left.querySelectorAll('.dmd-lnk'), h = null, m = null;
      for (var i = 0; i < ls.length; i++) {
        var t = ls[i].textContent.trim();
        if (t === 'Hombre') h = ls[i]; else if (t === 'Mujer') m = ls[i]; else left.removeChild(ls[i]);
      }
      if (h && m) {
        var prev = m;
        EXTRA.forEach(function (x) {
          var a = document.createElement('a');
          a.className = m.className; a.href = x[1]; a.textContent = x[0];
          prev.parentNode.insertBefore(a, prev.nextSibling); prev = a;
        });
        left.setAttribute('data-r2', '1');
      }
    }
    if (left && left.getAttribute('data-r2') && !left.getAttribute('data-r3')) {
      wrapDD(left);
      left.setAttribute('data-r3', '1');
    }
    var inn = document.querySelector('.header__inner');
    if (inn && !inn.querySelector('.dmd-top')) {
      var tp = document.createElement('div');
      tp.className = 'dmd-top';
      TOP.forEach(function (x) {
        var a = document.createElement('a');
        a.href = x[1]; a.textContent = x[0];
        tp.appendChild(a);
      });
      inn.appendChild(tp);
    }
  }

  function alignTop() {
    if (!mq.matches) return;
    var inn = document.querySelector('.header__inner'), tp = inn && inn.querySelector('.dmd-top');
    if (!tp) return;
    var items = inn.querySelectorAll('nav.header__utils .header__utils-item');
    var last = null;
    for (var i = items.length - 1; i >= 0; i--) { if (items[i].offsetWidth > 0) { last = items[i]; break; } }
    if (!last) return;
    var ic = last.querySelector('svg') || last;
    var r = ic.getBoundingClientRect(), ir = inn.getBoundingClientRect();
    if (!r.width) return;
    tp.style.setProperty('right', Math.max(0, Math.round(ir.right - r.right)) + 'px', 'important');
  }

  var GP = 'html.dmd-on.drop-float :is(#dhg-a,*) :is(#dhg-b,*) ';
  var GH = 'html.dmd-hov.dmd-on.drop-float :is(#dhg-a,*) :is(#dhg-b,*) ';
  var GHL = 'html.dmd-hov-l.dmd-on.drop-float :is(#dhg-a,*) :is(#dhg-b,*) ';
  var GS = 'html.dmd-on.drop-float.drop-hdr-scrolled :is(#dhg-a,*) :is(#dhg-b,*) ';
  var GFO = 'html.dmd-fo.dmd-on.drop-float :is(#dhg-a,*) :is(#dhg-b,*) ';
  var TY = 'font-family:var(--font-header,"Helvetica Neue",Arial,sans-serif) !important;font-size:var(--body-size,13px) !important;font-weight:var(--font-weight-normal,400) !important;letter-spacing:.04em !important;text-transform:capitalize !important;';
  var DDF = 'font-family:var(--font-header,"Helvetica Neue",Arial,sans-serif) !important;text-transform:none !important;';
  var DL = GP + '.header .dmd-left ';
  /* ancho de una tarjeta de Colecciones; la foto lateral = alto de tarjeta (4/5 + 48px de textos) menos 15px de ancho */
  var CW = '((100vw - 58px) / 5.3)';
  var GCSS = '.dmd-dd{display:none}' +
    '@media (min-width:990px){' +
    GP + '.header .header__inner{background:transparent !important;-webkit-backdrop-filter:none !important;backdrop-filter:none !important;border:0 !important;box-shadow:none !important;border-radius:0 !important;margin-top:0 !important}' +
    GP + '.header .header__logo{left:32px !important;right:auto !important;top:calc(50% + 7px) !important;margin:0 !important;transform:translateY(-50%) !important;z-index:70 !important}' +
    /* v81: menú corrido un poco a la izquierda (60px) y con menos espacio entre ítems (18px) */
    GP + '.header .dmd-left{position:absolute !important;left:calc(50% - 60px) !important;top:calc(50% + 7px) !important;transform:translate(-50%,-50%) !important;margin:0 !important;gap:18px !important;align-items:center !important;z-index:60 !important}' +
    DL + '.dmd-burger{display:none !important}' +
    DL + '.dmd-lnk{' + TY + 'display:inline-flex !important;align-items:center !important;gap:6px !important;white-space:nowrap !important;position:relative !important;z-index:2 !important}' +
    /* v80: sin flechitas; al pasar el mouse el nombre se marca en negrilla (con trazo, para que no se corra el resto del menú) */
    DL + '.dmd-chv{display:none !important}' +
    DL + '.dmd-lnk:hover,' + DL + '.dmd-item:hover > .dmd-lnk,' + DL + '.dmd-item:focus-within > .dmd-lnk,' + DL + '.dmd-item.is-fo > .dmd-lnk{-webkit-text-stroke:.55px currentColor !important}' +
    DL + '.dmd-item{position:relative !important;display:flex !important;align-items:center !important}' +
    DL + '.dmd-dd{position:absolute !important;z-index:1 !important;display:none;margin:0 !important;padding:0 !important;text-align:left !important}' +
    DL + '.dmd-item:hover .dmd-dd,' + DL + '.dmd-item:focus-within .dmd-dd{display:block !important}' +
    /* vidrio esmerilado: blanco translúcido + desenfoque de lo que hay detrás */
    DL + '.dmd-dd-in{background:rgba(255,255,255,.82) !important;-webkit-backdrop-filter:blur(28px) saturate(1.15) !important;backdrop-filter:blur(28px) saturate(1.15) !important;color:#000 !important;display:flex !important;align-items:flex-start !important;gap:0 !important;padding:calc(var(--hh,100px) + 12px) 32px 50.75px !important;box-sizing:border-box !important;width:100% !important;box-shadow:0 14px 30px rgba(0,0,0,.06) !important;white-space:nowrap !important;overflow:hidden !important}' +
    /* v81: columnas más juntas y letra más pequeña */
    DL + '.dmd-dl,' + DL + '.dmd-dg{flex:0 1 auto !important;min-width:0 !important;width:150px !important;box-sizing:border-box !important;padding-right:16px !important}' +
    DL + '.dmd-dg2{width:300px !important}' +
    DL + '.dmd-dl ul,' + DL + '.dmd-dg ul{list-style:none !important;margin:0 !important;padding:0 !important}' +
    DL + '.dmd-dl li,' + DL + '.dmd-dg li{margin:0 !important;padding:0 !important;break-inside:avoid}' +
    DL + '.dmd-dl p,' + DL + '.dmd-dg p{' + DDF + 'margin:0 0 16px !important;padding:0 !important;border:0 !important;font-size:15px !important;line-height:18px !important;font-weight:700 !important;letter-spacing:-.03em !important;color:#000 !important}' +
    DL + '.dmd-dl a{' + DDF + 'display:block !important;padding:0 !important;margin:0 0 2px !important;font-size:17px !important;line-height:22px !important;font-weight:500 !important;letter-spacing:-.02em !important;color:#000 !important;text-decoration:none !important;opacity:1 !important}' +
    DL + '.dmd-dg2 ul{column-count:2 !important;column-gap:16px !important}' +
    DL + '.dmd-dg a{' + DDF + 'display:block !important;padding:3px 0 !important;font-size:12px !important;line-height:17px !important;font-weight:400 !important;letter-spacing:-.01em !important;color:#000 !important;text-decoration:none !important;opacity:1 !important}' +
    DL + '.dmd-dl a:hover,' + DL + '.dmd-dg a:hover{text-decoration:underline !important;text-underline-offset:4px}' +
    /* v81: dos fotos editoriales a la derecha, una junto a la otra (v82: sin título y sin capa oscura encima) */
    DL + '.dmd-dimg{position:relative !important;display:block !important;flex:0 1 calc(' + CW + ' + 23.4px) !important;min-width:150px !important;margin-left:auto !important;width:calc(' + CW + ' + 23.4px) !important;aspect-ratio:4/5 !important;height:auto !important;overflow:hidden !important;border-radius:4px !important;background:#efefef !important;text-decoration:none !important}' +
    DL + '.dmd-dimg + .dmd-dimg{margin-left:8px !important}' +
    DL + '.dmd-dimg img{display:block !important;position:absolute !important;inset:0 !important;width:100% !important;height:100% !important;object-fit:cover !important}' +
    /* v92: menú en pantalla completa, fondo blanco sólido, se abre con clic */
    DL + '.dmd-full{position:absolute !important;display:none !important;margin:0 !important;z-index:1 !important;background:#fff !important;color:#000 !important;box-sizing:border-box !important;text-align:left !important;white-space:normal !important;overflow:hidden !important}' +
    DL + '.dmd-item.is-fo > .dmd-full{display:grid !important;grid-template-columns:minmax(300px,24%) minmax(0,1fr) !important;grid-template-rows:minmax(0,1fr) !important;column-gap:40px !important;padding:var(--hh,80px) 42px 42px 60px !important}' +
    GFO + '.header .dmd-left .dmd-dd{display:none !important}' +
    'html.dmd-fo{overflow:hidden !important}' +
    DL + '.dmd-fl{padding-top:60px !important;align-self:start !important;overflow:auto !important;max-height:100% !important}' +
    DL + '.dmd-fl details{border:0 !important;margin:0 !important;padding:0 !important}' +
    DL + '.dmd-fl summary{' + DDF + 'list-style:none !important;display:flex !important;align-items:center !important;justify-content:space-between !important;cursor:pointer !important;padding:11px 0 !important;font-size:15px !important;line-height:22px !important;font-weight:400 !important;letter-spacing:0 !important;color:#000 !important}' +
    DL + '.dmd-fl summary::-webkit-details-marker{display:none !important}' +
    DL + '.dmd-fl summary .dmd-fc{flex:none !important;margin-right:6px !important;transition:transform .2s ease}' +
    DL + '.dmd-fl details[open] summary .dmd-fc{transform:rotate(180deg)}' +
    DL + '.dmd-fl ul{list-style:none !important;margin:0 0 10px !important;padding:0 !important}' +
    DL + '.dmd-fl li{margin:0 !important;padding:0 !important}' +
    DL + '.dmd-fl li a{' + DDF + 'display:block !important;padding:5px 0 5px 14px !important;font-size:14px !important;line-height:20px !important;font-weight:400 !important;letter-spacing:0 !important;color:#444 !important;text-decoration:none !important}' +
    DL + '.dmd-fl li a:hover,' + DL + '.dmd-fall:hover{text-decoration:underline !important;text-underline-offset:4px;color:#000 !important}' +
    DL + '.dmd-fall{' + DDF + 'display:block !important;padding:11px 0 !important;font-size:15px !important;line-height:22px !important;font-weight:400 !important;letter-spacing:0 !important;color:#000 !important;text-decoration:none !important}' +
    DL + '.dmd-fp{display:flex !important;gap:10px !important;min-height:0 !important;height:100% !important}' +
    DL + '.dmd-fph{position:relative !important;display:block !important;flex:1 1 0 !important;min-width:0 !important;border-radius:4px !important;overflow:hidden !important;background:#efefef !important;text-decoration:none !important;color:#fff !important}' +
    DL + '.dmd-fph img{display:block !important;position:absolute !important;inset:0 !important;width:100% !important;height:100% !important;object-fit:cover !important}' +
    DL + '.dmd-fph::after{content:"";position:absolute;inset:0;background:linear-gradient(to top,rgba(0,0,0,.4),rgba(0,0,0,0) 45%);pointer-events:none}' +
    DL + '.dmd-flb{position:absolute !important;left:26px !important;bottom:26px !important;z-index:2 !important;display:block !important}' +
    DL + '.dmd-flb strong{' + DDF + 'display:block !important;font-size:15px !important;line-height:20px !important;font-weight:600 !important;letter-spacing:0 !important;color:#fff !important}' +
    DL + '.dmd-flb em{' + DDF + 'display:block !important;margin-top:14px !important;font-size:14px !important;line-height:20px !important;font-style:normal !important;font-weight:400 !important;letter-spacing:0 !important;color:#fff !important;text-decoration:underline !important;text-underline-offset:4px}' +
    DL + '.dmd-fx{position:absolute !important;top:calc(var(--hh,80px) + 20px) !important;right:58px !important;z-index:5 !important;width:36px !important;height:36px !important;display:flex !important;align-items:center !important;justify-content:center !important;background:transparent !important;border:0 !important;padding:0 !important;color:#fff !important;cursor:pointer !important}' +
    DL + '.dmd-fx svg{width:24px !important;height:24px !important;stroke-width:1.6 !important}' +
    '}' +
    '@media (min-width:990px) and (max-width:1439px){' +
    DL + '.dmd-dd-in{padding-left:24px !important;padding-right:24px !important}' +
    DL + '.dmd-dl,' + DL + '.dmd-dg{width:128px !important;padding-right:12px !important}' +
    DL + '.dmd-dg2{width:250px !important}' +
    DL + '.dmd-dg2 ul{column-gap:12px !important}' +
    DL + '.dmd-dl a{font-size:16px !important;line-height:21px !important}' +
    '}' +
    '@media (min-width:990px){' +
    DL + '.dmd-dd-in.dmd-dd-cards{display:block !important;padding:calc(var(--hh,100px) + 12px) 0 32px 16px !important}' +
    DL + '.dmd-cards{display:flex !important;gap:8px !important;width:100% !important;overflow-x:auto !important;overflow-y:hidden !important;scrollbar-width:none !important;-ms-overflow-style:none !important;scroll-snap-type:x proximity}' +
    DL + '.dmd-cards::-webkit-scrollbar{display:none !important}' +
    DL + '.dmd-card{display:block !important;flex:0 0 calc(' + CW + ') !important;min-width:0 !important;text-decoration:none !important;color:#000 !important;scroll-snap-align:start}' +
    DL + '.dmd-cimg{display:block !important;width:100% !important;aspect-ratio:4/5 !important;overflow:hidden !important;border-radius:4px !important;background:#efefef !important}' +
    DL + '.dmd-cimg img{display:block !important;width:100% !important;height:100% !important;object-fit:cover !important;transition:transform .35s ease}' +
    DL + '.dmd-card:hover .dmd-cimg img{transform:scale(1.03)}' +
    DL + '.dmd-card strong{' + DDF + 'display:block !important;margin-top:8px !important;font-size:16px !important;line-height:20px !important;font-weight:500 !important;letter-spacing:-.02em !important;color:#000 !important}' +
    DL + '.dmd-card em{' + DDF + 'display:block !important;margin-top:0 !important;font-size:12px !important;line-height:17px !important;font-style:normal !important;font-weight:400 !important;letter-spacing:-.02em !important;color:#000 !important}' +
    GH + '.header .dmd-left .dmd-lnk{color:#000 !important}' +
    GH + '.header .dmd-top a{color:#000 !important}' +
    GHL + '.header .header__logo,' + GHL + '.header .header__utils{filter:invert(1) !important}' +
    GP + '.header .header__utils{position:relative !important;z-index:70 !important}' +
    GS + '.header .header__logo{top:50% !important}' +
    GS + '.header .dmd-left{top:50% !important}' +
    GS + '.header .dmd-top{display:none !important}' +
    GP + '.header .header__utils{display:flex !important;align-items:center !important;justify-content:flex-end !important;gap:28px !important;margin:0 32px 0 auto !important;align-self:center !important}' +
    GP + '.header .header__utils .dmd-rl{display:none !important}' +
    GP + '.header .header__utils .drop-srch__f{display:none !important}' +
    GP + '.header .dmd-top{position:absolute !important;top:8px !important;right:32px !important;display:flex !important;align-items:center !important;gap:22px !important;z-index:70 !important}' +
    GP + '.header .dmd-top a{font-family:var(--font-header,"Helvetica Neue",Arial,sans-serif) !important;font-size:11px !important;font-weight:400 !important;letter-spacing:.02em !important;text-transform:none !important;color:var(--dmd-c,#fff) !important;text-decoration:none !important;white-space:nowrap !important;opacity:.9}' +
    GP + '.header .dmd-top a:hover{opacity:1 !important;text-decoration:underline !important;text-underline-offset:3px}' +
    '}';
  function glass() {
    if (document.getElementById('dhg-css')) return;
    var s = document.createElement('style'); s.id = 'dhg-css'; s.textContent = GCSS;
    document.head.appendChild(s);
  }

  function col() {
    if (document.documentElement.classList.contains('dmd-hov-l')) return;
    var i = document.querySelector('nav.header__utils .header__utils-link, nav.header__utils button');
    if (i) document.documentElement.style.setProperty('--dmd-c', getComputedStyle(i).color);
  }
  var tk; function tick() { if (tk) return; tk = setTimeout(function () { tk = 0; col(); alignTop(); }, 60); }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', function () { tick(); closeFull(); if (!mq.matches) { close(); cleanup(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeFull(); close(); } });

  function init() { wire(); if (!mq.matches) { cleanup(); return; } col(); links(); glass(); alignTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  setInterval(init, 1000);
})();
